export default class Clients {
    index = -1;
    count = 1;
    constructor({ el }) {
        this.el = el;

        this.initialize();
        this.moave();
    }
    initialize() {
        this.$thumbs = this.el.querySelectorAll(".wp-block-omnicom-call-to-action");
        // this.count = this.$data.length
        
        // this.setIndex(0);

        this.$thumbs.forEach((thumb, index) => {
            thumb.classList.add("big-layout");
            thumb.addEventListener("click", () => this.setIndex(thumb));
        });
        
    }
    moave() {

        
        const controls = this.el.querySelector('.controls');
        const items = Array.from(this.el.querySelectorAll('.wp-block-omnicom-call-to-action:not(.wp-block-omnicom-call-to-action--more)'));
        let moreButton = null;
        let isShowingAll = false;

        function manageItems() {
            // Reset any existing modifications
            items.forEach(item => {
                item.classList.remove('hidden');
                item.style.display = 'inline-flex'; // Ensure items are visible for measurement
            });
            if (moreButton) {
                moreButton.remove();
                moreButton = null;
            }
            controls.classList.remove('show-all');
            isShowingAll = false;

            // Get the container's right edge
            if (items.length === 0) return;
            const containerRight = controls.getBoundingClientRect().right - 35;

            // Find items that overflow to the right
            const hiddenItems = items.filter(item => item.getBoundingClientRect().right > containerRight);

            // If there are hidden items, add the "More" button and animate
            if (hiddenItems.length > 0) {
                // Capture the state of the controls container
                const state = Flip.getState(controls, { props: 'opacity,visibility,position,display' });

                // Hide items that overflow
                hiddenItems.forEach(item => item.classList.add('hidden'));

                // Create the "More" button if not already present
                if (!moreButton) {
                    moreButton = document.createElement('span');
                    moreButton.classList.add('wp-block-omnicom-call-to-action', 'wp-block-omnicom-call-to-action--more');
                    moreButton.innerHTML = `
                       <svg width="35" height="24" viewBox="0 0 35 24" fill="none" xmlns="http://www.w3.org/2000/svg" class="more" aria-hidden="true">
                            <rect x="0.5" y="0.5" width="33.5234" height="23" rx="11.5" stroke="#898989"/>
                            <path d="M21.5312 12.9844C21.2396 12.9844 20.9974 12.8906 20.8047 12.7031C20.612 12.5104 20.5156 12.276 20.5156 12C20.5156 11.7135 20.612 11.4792 20.8047 11.2969C20.9974 11.1094 21.2396 11.0156 21.5312 11.0156C21.8177 11.0156 22.0547 11.1094 22.2422 11.2969C22.4297 11.4792 22.5234 11.7135 22.5234 12C22.5234 12.276 22.4297 12.5104 22.2422 12.7031C22.0547 12.8906 21.8177 12.9844 21.5312 12.9844Z" fill="#898989"/>
                            <path d="M17.2734 12.9844C16.9818 12.9844 16.7396 12.8906 16.5469 12.7031C16.3542 12.5104 16.2578 12.276 16.2578 12C16.2578 11.7135 16.3542 11.4792 16.5469 11.2969C16.7396 11.1094 16.9818 11.0156 17.2734 11.0156C17.5599 11.0156 17.7969 11.1094 17.9844 11.2969C18.1719 11.4792 18.2656 11.7135 18.2656 12C18.2656 12.276 18.1719 12.5104 17.9844 12.7031C17.7969 12.8906 17.5599 12.9844 17.2734 12.9844Z" fill="#898989"/>
                            <path d="M13.0156 12.9844C12.724 12.9844 12.4818 12.8906 12.2891 12.7031C12.0964 12.5104 12 12.276 12 12C12 11.7135 12.0964 11.4792 12.2891 11.2969C12.4818 11.1094 12.724 11.0156 13.0156 11.0156C13.3021 11.0156 13.5391 11.1094 13.7266 11.2969C13.9141 11.4792 14.0078 11.7135 14.0078 12C14.0078 12.276 13.9141 12.5104 13.7266 12.7031C13.5391 12.8906 13.3021 12.9844 13.0156 12.9844Z" fill="#898989"/>
                        </svg>

                    `;
                    controls.appendChild(moreButton);
                }

                // Animate the layout change
                Flip.from(state, {
                    duration: 0.5,
                    ease: 'power2.out',
                    absolute: true,
                    onComplete: () => {
                        // After animation, set display: none for hidden items
                        hiddenItems.forEach(item => {
                            item.style.display = 'none';
                        });
                    }
                });

                // Remove any existing event listeners to prevent duplicates
                moreButton.removeEventListener('click', toggleItems);
                moreButton.addEventListener('click', toggleItems);
            }
        }

        function toggleItems() {
            // Capture the current state of the controls container
            const state = Flip.getState(controls, { props: 'height,scale' });

            // Toggle the show-all state
            isShowingAll = !isShowingAll;
            controls.classList.toggle('show-all', isShowingAll);

            // Show or hide items based on the state
            if (isShowingAll) {
                items.forEach(item => {
                    item.classList.remove('hidden');
                    item.style.display = 'inline-flex';
                });
                if (moreButton) {
                    moreButton.style.display = 'none';
                }
            } else {
                const containerRight = controls.getBoundingClientRect().right;
                items.forEach(item => {
                    if (item.getBoundingClientRect().right > containerRight) {
                        item.classList.add('hidden');
                    } else {
                        item.classList.remove('hidden');
                        item.style.display = 'inline-flex';
                    }
                });
                if (moreButton) {
                    moreButton.style.display = 'inline-flex';
                }
            }

            // Animate the layout change
            Flip.from(state, {
                duration: 0.5,
                ease: 'power2.out',
                onComplete: () => {
                    if (!isShowingAll) {
                        items.forEach(item => {
                            if (item.classList.contains('hidden')) {
                                item.style.display = 'none';
                            }
                        });
                    }
                }
            });
        }

        // Run on load
        if (window.innerWidth < 768) manageItems();
    }
    setIndex(activeThumb) {      
        const state = Flip.getState(this.el.querySelector(".wrapper"));
        this.$groups = this.el.querySelectorAll(".client-group");

        this.$groups.forEach((thumb) => {
            if (thumb.classList.contains(activeThumb.dataset.id)) {
                thumb.classList.add("active");
                gsap.from(thumb.querySelectorAll(".client-item"), { alpha: 0, delay: .25, ease: "power2.out", duration: .25, stagger: 0.05, z: 100, y: 50 });
            } else if (thumb.classList.contains("active")) {
                const leaver = thumb;
                gsap.set(leaver, { position: "absolute", left: 0, top: 0, right: 0});
                gsap.to(leaver, { alpha: 0, z: -100, duration: .25, ease: "power2.in", clearProps: "all", onComplete: () => {
                    leaver.classList.remove("active");
                }});
            }
        });
        this.$thumbs.forEach((thumb) => {
            thumb.classList.remove("active");
        });
        activeThumb.classList.add("active");

        Flip.from(state, {
            duration: 0.628 ,
            ease: "quint.out",
            onComplete: () => {
                ScrollTrigger.refresh();
            }
        });
    } 

    dispose() {

    }
}